import { styled } from '@mui/material/styles';
import { TextField } from '@mui/material';

const ShvkTextField = styled(TextField)({
    '& .MuiOutlinedInput-root.Mui-disabled': {
        backgroundColor: 'rgba(0, 0, 0, 0.03);',
    },
});
export default ShvkTextField;
